export default __webpack_public_path__ + "9e8c6042f37a06200de37b906aece3e0.jpg";